window.materialGallery = function (images, title) {
  return {
    open: false,
    current: 0,
    images: images,
    title: title,
    openModal: function (index) {
      this.current = typeof index === 'number' ? index : 0;
      this.open = true;
      document.documentElement.classList.add('is-materials-modal-open');
      this._preload();
    },
    closeModal: function () {
      this.open = false;
      document.documentElement.classList.remove('is-materials-modal-open');
    },
    prev: function () {
      this.current = (this.current - 1 + this.images.length) % this.images.length;
    },
    next: function () {
      this.current = (this.current + 1) % this.images.length;
    },
    _preload: function () {
      this.images.forEach(function (src) {
        var img = new Image();
        img.src = src;
      });
    },
  };
};
